module.exports = __webpack_public_path__ + "static/media/LABRA_HR.745f33bc.png";